import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';
import { transformTagNames } from '../../global/transform-tag-name';

/**
 * @slot - contents placed within the navigation item
 */
@Component({
  tag: 'wb-header-language-menu-item',
  styleUrl: 'header-language-menu-item.scss',
  shadow: true,
})
export class HeaderLanguageMenuItemComponent implements ComponentInterface {
  /** marks the navigation item as active */
  @Prop({ reflect: true })
  public active: boolean;

  /** passed through to internal <a> */
  @Prop()
  public href: string;

  /** passed through to internal <a> */
  @Prop()
  public referrerPolicy: ReferrerPolicy;

  /** passed through to internal <a> */
  @Prop()
  public rel: string;

  /** passed through to internal <a> */
  @Prop()
  public target: string;

  private TagNames = transformTagNames(this, 'wb-header-language-menu-item', ['wb-text']);

  public render(): JSX.Element {
    const { WbText } = this.TagNames;

    return (
      <Host class="wb-header-language-menu-item">
        <WbText size="s" static strong={this.active}>
          {this.href ? (
            <a href={this.href} target={this.target} rel={this.rel} class="item">
              <div class="item-inner">
                <slot />
              </div>
            </a>
          ) : (
            <span class="item">
              <div class="item-inner">
                <slot />
              </div>
            </span>
          )}
        </WbText>
      </Host>
    );
  }
}
